export enum TagsDataTypes {
  DOKUMENTS = 'attachment',
  EXPENSE = 'invoice',
  INCOME = 'income',
  TAX = 'tax',
}
